import { ExclusiveLabel } from "@components/ExclusiveLabel";
import { Row } from "@components/Flex";
import { GoalIcon } from "@components/Goals/GoalIcon";
import { Overlay } from "@components/Overlay";
import { OverlayProps } from "@components/Overlay/types";
import { Spacing, SpacingSizes } from "@components/Spacing";
import { Body, Title3, Title4 } from "@components/Typography";
import { useModal } from "@hooks";
import { i18n, Translations } from "@i18n";
import { convertCentsToDollar, formatCurrency } from "@utils";
import { useStyles } from "./styles";
import { ACHReturnModalProps } from "./types";

export const ACHReturnModal = ({ item }: ACHReturnModalProps) => {
  const styles = useStyles();

  const { dismiss } = useModal();

  const amount = formatCurrency(convertCentsToDollar(item.amountInCents), true);

  const props: OverlayProps = {
    cta: {
      secondary: {
        title: i18n.t(Translations.ACHReturnModalPrimaryCTA),
        onClick: dismiss,
      },
    },
  };

  return (
    <Overlay {...props}>
      <Title3>{item.description}</Title3>
      <Spacing size={SpacingSizes.S} />

      <Row style={styles.row}>
        <GoalIcon type={item.goalType} />
        <Title4 style={styles.goalName}>{item.goalName}</Title4>
      </Row>
      <Spacing size={SpacingSizes.S} />

      {item.beneficiaryName && item.amountInCents != null ? (
        <>
          <div style={styles.row}>
            <ExclusiveLabel style={styles.exclusive}>{item.beneficiaryName}</ExclusiveLabel>
            <Title4 style={styles.goalLabel}>{amount}</Title4>
          </div>
          <Spacing size={SpacingSizes.XL} />
        </>
      ) : null}

      <Body>{i18n.t(Translations.ACHReturnModalText)}</Body>
      <Spacing size={SpacingSizes.M} />

      <Body>{i18n.t(Translations.ACHReturnModalSubText)}</Body>
      <Spacing size={SpacingSizes.M} />
    </Overlay>
  );
};
